
























































import Vue from 'vue'
import Component from 'vue-class-component'

import { ChartType } from 'chart.js/dist/Chart.js'

import 'chartjs-plugin-colorschemes/src/plugins/plugin.colorschemes'
import { Damask6 } from 'chartjs-plugin-colorschemes/src/colorschemes/colorschemes.office'

import { Investment, PaymentStatus } from '@/interfaces/investment'
import { Watch } from 'vue-property-decorator'
import * as Chart from 'chart.js/dist/Chart.js'

import { mapGetters } from 'vuex'

const ChartJS = (window as any).Chart

interface RevenuesOptions {
  selectedYears: number[];
}

@Component({
  computed: {
    ...mapGetters({
      investments: 'investment/investments',
      loading: 'investment/loading'
    })
  }
})
export default class RevenuesByMonth extends Vue {
  investments!: Investment[]

  $moment;

  revenuesChart!: ChartType

  years: number[] = [2017, 2018, 2019, 2020, 2021]

  options: RevenuesOptions = {
    selectedYears: [2017, 2018, 2019, 2020, 2021]
  }

  labels: string[] = []

  datasets: Chart.ChartDataSets[] = []

  formState = {
    loading: false
  }

  state = {
    loading: false
  }

  @Watch('investments')
  async onInvestmentsChange(cur: Investment[]) {
    if (!cur.length) return

    this.datasets = await this.buildDatasets(this.paidInvestments, this.options.selectedYears)

    this.renderChart(this.revenuesChart, this.labels, this.datasets)
  }

  get paidInvestments() {
    return this.investments.filter((i) => PaymentStatus[i.pagamento.status] === PaymentStatus.PAGO)
  }

  async mounted() {
    this.labels = this.buildLabels()

    this.initRevenuesChart()
  }

  renderChart(chart, labels, datasets) {
    chart.data.labels = labels
    chart.data.datasets = datasets

    chart.update()
  }

  initRevenuesChart() {
    const ctx = (this.$refs.revenuesChart as any).getContext('2d')

    this.revenuesChart = new ChartJS(ctx, {
      type: 'bar',
      options: {
        plugins: {
          colorschemes: {
            scheme: Damask6
          }
        },
        tooltips: {
          mode: 'index',
          intersect: false,
          callbacks: {
            label: (tooltipItem, data) => {
              const datasetIndex = tooltipItem.datasetIndex
              const datasetLabel = data.datasets[datasetIndex].label

              const label = this.$options.filters?.currency(tooltipItem.yLabel)
              return `${datasetLabel} - ${label}`
            }
          }
        },
        maintainAspectRatio: false,
        responsive: true,
        scales: {
          xAxes: [{
            stacked: true
          }],
          yAxes: [{
            stacked: true,
            ticks: {
              beginAtZero: true,
              fontSize: 16,
              padding: 20,
              callback: (value) => {
                return this.$options.filters?.currency(value)
              }
            }
          }]
        }
      }
    })
  }

  buildDatasets(investments: Investment[], years: number[]) {
    const dataset = years.map((year) => {
      const invs = investments.filter((i) => {
        return this.$moment(i.pagamento.criado).year() === year
      })

      const data: number[] = this.labels.map((month: string) => {
        const currentMonthInvs = invs.filter(i => {
          const paidMonth = this.$moment(i.pagamento.criado).format('MMM')
          return paidMonth === month
        })

        return currentMonthInvs.reduce((acc, cur) => {
          acc += cur.valor
          return acc
        }, 0)
      })

      return {
        label: year.toString(),
        data
      }
    })

    return Promise.resolve(dataset)
  }

  async onFormSubmit() {
    this.formState.loading = true

    // Esse timeout é necessário para o componente innercontent ter tempo de blocar a tela.
    setTimeout(() => {
      this.buildDatasets(this.paidInvestments, this.options.selectedYears)
        .then((datasets) => {
          this.datasets = datasets

          this.formState.loading = false
          this.renderChart(this.revenuesChart, this.labels, this.datasets)
        })
    }, 100)
  }

  buildLabels() {
    return this.$moment.monthsShort()
  }
}
